import {  sendApi } from ".";
import { T_Place } from "../model/placeModel";

async function placeList(data?: any) {
    const response = await sendApi({
      method: "post",
      url: "/place/list",
      data: {
        ...data,
      },
    });
    return response;
  }

async function placeCreate(data1?:T_Place){

  const response = await sendApi({
    method: "post",
    url: "/place/insert",
    data: {
      ...data1,
    },
  });

  
  return response;
}  

async function placeDelete(data1?:T_Place){

  const response = await sendApi({
    method: "post",
    url: "/place/delete",
    data: {
      ...data1,
    },
  });

  return response;
}  

async function placeInfo(data?: any) {
    const response = await sendApi({
      method: "post",
      url: "/place/info",
      data: {
        ...data,
      },
    });
    return response;
  }

  async function placeUpdate(data?: any) {
    const response = await sendApi({
      method: "post",
      url: "/place/update",
      data: {
        ...data,
      },
    });
    return response;
  }


const place = {
    placeList,
    placeCreate,
    placeDelete,
    placeInfo,
    placeUpdate
  };
  export default place;

